export const getImageDimensions = (image?: { filename: string }): { width: number, height: number } => {
  if (!image?.filename) return { height: NaN, width: NaN }
  const { width, height } = ((/(?<width>\d*)x(?<height>\d*)/u).exec(image.filename))?.groups ?? { height: "", width: "" }
  return { height: parseInt(height, 10), width: parseInt(width, 10) }
}
